import { xhrApiClient } from '@/config/xhrApiClient'

const postUpsertUser = async () => {
    return await xhrApiClient.post('/api/auth/signin')
}

export default postUpsertUser
